import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { useSelector } from "react-redux";

const useCheckIsForushgah = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useSelector((store) => store.userReducer);
  const { profileData } = useSelector((state) => state.userProfileReducer);

  useEffect(() => {
    if (
      token &&
      profileData?.isFrushgah === false &&
      (location.pathname === "/producersProducts" ||
        location.pathname === "/producerProductDetails")
    ) {
      navigate("/");
    }
  }, [token, profileData, location]);
};

export default useCheckIsForushgah;
